import React, { useMemo } from 'react';
import Spinner from '../spinner';
import { t } from 'i18next';
import { DataTableColumn, PaginationProps } from './types';

type Props = {
  pagination: PaginationProps | undefined;
  loading: boolean | undefined;
  onShowMore?: () => void;
  columns: DataTableColumn[];
};

const TableFooter = ({ loading, onShowMore, columns, pagination }: Props) => {
  const tdClass =
    'tw-border-b tw-border-x tw-border-t-0 tw-border-gray-100 tw-border-solid ' +
    'tw-rounded-bl-lg tw-rounded-br-lg tw-text-center';

  const useCursor = pagination?.useCursor || false;
  const useOffset = pagination?.useOffset || false;
  const totalCount = pagination?.total_count || 0;
  const offset = pagination?.offset || 0;
  const limit = pagination?.limit || 0;

  const hasMore = useMemo(() => {
    if (useCursor) {
      return !!pagination?.next_cursor;
    }
    if (useOffset) {
      return totalCount > offset + limit;
    }
    return false;
  }, [totalCount, offset, limit, useCursor, useOffset, pagination?.next_cursor]);

  if (!hasMore && !loading) {
    return null;
  }

  return (
    <tfoot>
      <tr>
        <td className={tdClass} colSpan={columns.length}>
          <div
            className="tw-flex tw-justify-center tw-items-center tw-py-2 tw-font-medium tw-text-gray-500 tw-cursor-pointer"
            onClick={!loading ? onShowMore : undefined}
            role="button"
          >
            {loading ? <Spinner centered /> : t('common:table_show_more')}
          </div>
        </td>
      </tr>
    </tfoot>
  );
};

export default TableFooter;
